import { useCallback } from "react";
import { SendATest } from "../../../../externalComponents/SendATest";
import {
  Dialog,
  DialogBody,
  DialogTitle,
} from "../../../../externalComponents/tailwind/dialog";

const SendTestDialog = ({ modalRef, setModalRef, user }) => {
  const handleClose = useCallback(() => {
    setModalRef((_modalRef) => ({
      ..._modalRef,
      sendTest: false,
    }));
  }, [modalRef.sendTest]);

  return (
    <Dialog open={modalRef.sendTest} onClose={handleClose}>
      <DialogTitle>Send a test now</DialogTitle>
      <DialogBody>
        <SendATest user={user} />
      </DialogBody>
    </Dialog>
  );
};

export default SendTestDialog;
